import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import PropTypes from "prop-types";

import Button from "../../Button";

export default function UserIdModal({
  open,
  heading,
  description,
  buttonText,
  subText,
  onClick,
  onOpenChange,
}) {
  return (
    <Transition.Root show={open} as={React.Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        open={open}
        onClose={onOpenChange}
        data-testid="user-identification-modal"
      >
        <div className="flex items-center justify-center h-screen text-center px-sm">
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block align-middle h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block w-full md:w-screen-xs p-md my-8 align-middle bg-white rounded-lg text-center overflow-hidden transform transition-all">
              <div>
                {/* <div className="mx-auto flex items-center justify-center">
                  <img src="" alt={heading} />
                </div> */}
                <div className="flex flex-col space-y-md">
                  <Dialog.Title className="gn-headline-sm">
                    {heading}
                  </Dialog.Title>
                  <p
                    className="gn-text"
                    data-testid="user-identification-modal-description"
                  >
                    {description}
                  </p>
                  <div className="flex flex-col space-y-sm">
                    <Button
                      fullwidth
                      mode="dark-outline"
                      label={buttonText}
                      size="md"
                      testID="userIdentifyTeacherBtn"
                      onClick={() => {
                        onClick("unregistered_teacher");
                        onOpenChange(false);
                      }}
                    />
                    <Button
                      fullwidth
                      mode="dark-outline"
                      label={subText}
                      size="md"
                      testID="userIdentifyParentBtn"
                      onClick={() => {
                        onClick("unregistered_family");
                        onOpenChange(false);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

UserIdModal.propTypes = {
  open: PropTypes.bool,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func,
};

UserIdModal.defaultProps = {
  open: false,
  onOpenChange: () => {},
};
